import { render } from "./FormSite.vue?vue&type=template&id=7f802e59&ts=true"
import script from "./FormSite.vue?vue&type=script&lang=ts"
export * from "./FormSite.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__